import React from 'react'
import GiftCardConfirmPayPage from '../../components/User/GiftCardConfirmPayPage';

const GiftCardConfirmPayComp = () => {
  return (
    <GiftCardConfirmPayPage />
  )
}

export default GiftCardConfirmPayComp;